import z from "zod";

/** A price tier shared by any number of models, so a rate change is one edit. */
export const ModelPrice = z.object({
  label: z.string().optional(),
  ppmInputTokens: z.number(),
  ppmInputTokensCacheWrite5m: z.number(),
  ppmInputTokensCacheWrite1h: z.number(),
  ppmInputTokensCacheRead: z.number(),
  ppmOutputTokens: z.number(),
});

export type ModelPrice = z.infer<typeof ModelPrice>;
